//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

import {createStore} from "vuex";
import modules from "./modules";
import getters from "./getters";

const debug = process.env.NODE_ENV !== "production";

// 登出/换号时统一清理计分器子系统的实时连接与本地对局态，避免残留与跨账号串号
const subsystemCleanupPlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === "LOGOUT") {
      store.dispatch("scorer/disconnectWebSocket");
      store.commit("scorer/RESET_MATCH");
    }
  });
};

const store = createStore({
  modules,
  getters,
  strict: debug,
  plugins: [subsystemCleanupPlugin]
});
export default store;
